import { render, staticRenderFns } from "./Send_recovery.vue?vue&type=template&id=5a3ed0d9"
import script from "./Send_recovery.vue?vue&type=script&lang=js"
export * from "./Send_recovery.vue?vue&type=script&lang=js"
import style0 from "./Send_recovery.vue?vue&type=style&index=0&id=5a3ed0d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports